<template>
  <el-autocomplete
    placeholder="Email"
    v-model="email"
    :fetch-suggestions="searchCustomer"
    :debounce="500"
    :trigger-on-focus="false"
    value-key="email"
    @select="getCustomerDetails">
    <i class="el-input__icon" :class="[loading ? 'el-icon-loading' : 'el-icon-search']"
       slot="suffix">
    </i>
  </el-autocomplete>
</template>

<script>
  /* ============
   * Search User Component
   * ============
   *
   * Search user by email
   *
   * @emit onCustomerFound
   */
  import _ from 'lodash'

  import CustomerTransformer from '@/app/transformers/CustomerTransformer'
  import CustomerProxy from '@/app/proxies/CustomerProxy'

  export default {
    name: 'search-user',
    data () {
      return {
        customers: [],
        customersDetails: [],
        email: '',
        timeout: null,
        customerProxy: null,
        loading: false
      }
    },
    methods: {
      // Search customers by email
      searchCustomer (queryString, cb) {
        this.customerProxy
          .setParameter('email', encodeURIComponent(this.email))
          .setParameter('itemsPerPage', 10)
          .submit()
          .then(res => {
            const customers = res.data.map(customer => ({email: customer.email}))
            this.customers = _.uniqBy(customers, 'email')
            cb(this.customers)
          })
          .catch(err => {
            console.log(err)
          })
      },
      getCustomerDetails () {
        this.loading = true
        this.$api.customerEmailGet(
          {
            email: this.email
          })
          .then(res => {
            this.customersDetails = CustomerTransformer.fetchCollection(res['data'])
            this.$emit('onCustomerFound', this.customersDetails)
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            if (err.request.status === 404) {
              this.$emit('onCustomerFound', null)
            } else {
              this.$notify.error({
                title: 'Error',
                message: 'Error occured'
              })
            }
            this.loading = false
          })
      }
    },
    created () {
      this.customerProxy = new CustomerProxy()
    }
  }
</script>




// WEBPACK FOOTER //
// src/app/components/user/Search.vue